import { create, w } from '@dojo/framework/core/vdom';
import { ChartBase } from './base-chart';
const factory = create({}).properties();
export const DonutChart = factory(({ properties }) => {
    const { ariaLabel = 'donut chart', size, data, drawComplete, legend, options, plugins, pluginCode, title, alternateText } = properties();
    const type = 'doughnut';
    return w(ChartBase, {
        ariaLabel,
        alternateText,
        size,
        data,
        drawComplete,
        legend,
        options,
        plugins,
        pluginCode,
        title,
        type
    });
});
